<ng-select [items]="options"
           [placeholder]="placeholder"
           [(ngModel)]="value"
           (ngModelChange)="valueChanged()"
           bindLabel="label" bindValue="value"
           [appendTo]="appendTo">
</ng-select>
